import {Pipe, PipeTransform, SecurityContext} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Pipe to highlight matches in a string value that matches with the input query.
 * SECURITY: Sanitizes input to prevent XSS attacks before adding highlight spans
 */
@Pipe({
  name: 'highlightMatch'
})
export class HighlightMatchPipe implements PipeTransform {

	constructor(private sanitizer: DomSanitizer) {}

	transform(
		value: string,
		query: string,
		caseSensitive: boolean = false,
		highlightClasses: string = 'highlighted-text'
	): SafeHtml | string | null {
		if (!value || !query) {
			return value;
		}

		// SECURITY: First sanitize the input value to remove any existing HTML/XSS attempts
		const sanitizedValue = this.sanitizer.sanitize(SecurityContext.HTML, value) || '';

		// SECURITY: Escape the highlight class name to prevent attribute injection
		const safeClass = highlightClasses.replace(/[^a-zA-Z0-9_-]/g, '');

		const regex = new RegExp(
			query.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'),
			caseSensitive ? 'g' : 'gi'
		);

		const highlighted = sanitizedValue.replace(regex, match =>
			`<span class="${safeClass}">${match}</span>`
		);

		// SECURITY: Since we've already sanitized the input and only added safe HTML,
		// we can safely return the highlighted text
		// The browser will render <span> tags but any malicious content was removed by sanitization
		return highlighted;
	}

}
